import { GetVehiclesRequest, MyVehiclesResponse } from 'api/vehicles/vehicles.type';
import { cleanRut } from 'global/utils/rut/rut';

export const getSearchParams = (request: GetVehiclesRequest) => ({
  anno: request.filterBy,
  marca: request.filterBy?.toLowerCase(),
  patente: request.filterBy?.toUpperCase(),
  rut: cleanRut(request.rut).slice(0, -1),
});

export const transformResponse = (response: any): MyVehiclesResponse => ({
  success: true,
  total: response.result?.total || 0,
  vehicles:
    response.result?.data
      ?.filter((v: any) => v.marca && v.placa_patente)
      ?.map((v: any) => ({
        brand: v.marca,
        plate: v.placa_patente.toUpperCase(),
        status: v.estado,
        unique_id: v.unique_id,
        year: +v.anno > 0 && +v.anno,
      })) || [],
});
